import { Dropdown, getLocale, useTranslator } from "@sia/style-guide";
import { useCallback, useContext, useEffect, useState } from "react";
import { WizarContext, studentSectionInfoActionCreator } from "contexts/WizardContext";
import GlobalContext from "contexts/GlobalContext";
import webPlatformAdapter from "common/Adapters/WebPlatformAdapter/WebPlatformAdapter";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";
import { initialWizardFormState } from "contexts/WizardContext";

const SectionInfo = ({ errors, setErrors }) => {
  const translate = useTranslator();
  const { state, dispatch } = useContext(WizarContext);
  const { language } = useContext(GlobalContext);
  let sectionInfo = state.student.sectionInfo;
  let sectionsInfoErrors = errors.student.sectionInfo;
  let changState = useCallback((payload) => dispatch(studentSectionInfoActionCreator(payload)), [dispatch]);
  const resetInputFieldError = (property) => {
    if (errors.student.sectionInfo[property]) {
      setErrors((errorsState) => ({
        ...errorsState,
        student: {
          ...errorsState.student,
          sectionInfo: { ...errorsState.student.sectionInfo, [property]: "" },
        },
      }));
    }
  };

  const { user } = useContext(GlobalContext);
  const [sections, setSections] = useState([]);
  const [professionalGroups, setProfessionalGroups] = useState([]);
  const userId = user.siaId;

  const setUserSession = (obj) => {
    pgAdapter.getWizardSession(({ data }) => {
      const updatedSession = { ...data, student: { ...(data?.student || {}), sectionInfo: { ...(data?.student?.sectionInfo || {}), ...obj } } };
      pgAdapter.setWizardSession({ ...updatedSession });
    });
  };

  useEffect(() => {
    async function getLists() {
      let sections = await webPlatformAdapter.request("GET", "rpc/get_sia_sections_list", { lang: getLocale(language) }, null);
      sections = sections.map((e) => ({ id: e.id, label: e.name }));
      setSections(sections);
      let professionalGroups = await webPlatformAdapter.request("GET", "rpc/get_sia_bgs_list", { lang: getLocale(language) }, null);
      professionalGroups = professionalGroups.map((e) => ({ id: e.id, label: e.name }));
      setProfessionalGroups(professionalGroups);
    }
    if (user) {
      getLists();
    }
  }, [user, language]);

  useEffect(() => {
    if (userId) {
      pgAdapter.getWizardSession(({ data }) => {
        const defaultSectionInfo = { ...initialWizardFormState.student.sectionInfo };
        const { sectionInfo } = data.student;
        const { section, professionalGroup } = sectionInfo || defaultSectionInfo;
        changState({
          section,
          professionalGroup,
        });
      });
    }
  }, [userId, changState]);
  const selectedSeciton = sections.filter((e) => e.id === sectionInfo?.section?.id)[0];
  const selectedPg = professionalGroups.filter((e) => e.id === sectionInfo?.professionalGroup?.id)[0];
  return (
    <div className="section-info-page">
      <p>{translate("wizard.form.student.sections.info")}</p>
      <Dropdown
        id={"otherAddresses-page-contact"}
        label={translate("wizard.form.single.sections.price.example")}
        items={sections}
        value={selectedSeciton}
        required={true}
        onChange={(event, value) => {
          resetInputFieldError("section");
          changState({ section: value });
          setUserSession({ section: value });
        }}
        placeholder={translate("wizard.form.single.placeholder")}
        invalid={sectionsInfoErrors.section}
        invalidText={sectionsInfoErrors.section}
      />
      <p>{translate("wizard.form.single.sections.professional-group.info")}</p>
      <Dropdown
        id={"otherAddresses-page-contact-pg"}
        items={professionalGroups}
        value={selectedPg}
        required={true}
        onChange={(event, value) => {
          resetInputFieldError("professionGroup");
          changState({ professionalGroup: value });
          setUserSession({ professionalGroup: value });
        }}
        placeholder={translate("wizard.form.single.placeholder")}
        invalid={sectionsInfoErrors.professionalGroup}
        invalidText={sectionsInfoErrors.professionalGroup}
      />
    </div>
  );
};

export default SectionInfo;
